module.exports = __webpack_public_path__ + "img/cross.7ac42c95.svg";